import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    OnInit,
    ElementRef,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CommonLookupServiceProxy,
    FindCustomerOutputDto,
    FindProductOutputDto,
    TaxDto,
    CurrencyDto,
    Status,
    JournalDetailDto,
    ChartOfAccountDto,
    SalesNotesEditDto,
    SalesNotesDetailEditDto,
    SalesNotesServiceProxy,
    CreateOrUpdateSalesNotesInput,
    SalesNotesType,
    PaymentStatus,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { debug } from 'console';
import { forEach } from 'lodash-es';

@Component({
    templateUrl: './create-or-edit-salesnotes.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditSalesNotesComponent extends AppComponentBase implements OnInit {
    @ViewChildren('itemCodeInput') itemCodeInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('descriptionInputs') descriptionInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('subTotalInput') subTotalInput!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('taxInput') taxInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('addButton') addButtons!: QueryList<ElementRef<HTMLButtonElement>>;
    active = false;
    saving = false;
    customerSelectedItem: FindCustomerOutputDto;
    customers: FindCustomerOutputDto[];
    products: FindProductOutputDto[];
    applicableTaxes: TaxDto[];
    units: any[] = [];

    filterText = '';

    salesNotes: SalesNotesEditDto = new SalesNotesEditDto();
    salesNotesDetails: SalesNotesDetailEditDto[];
    salesNotesDetail: SalesNotesDetailEditDto = new SalesNotesDetailEditDto();
    allChartOfAccounts: ChartOfAccountDto[];
    bankAccounts: ChartOfAccountDto[];
    customerDisplayProperty = '';
    currencyName = '';
    paymentTermName = '';
    totalQty = 0;
    primaryCurrency = '';
    allCurrencys: CurrencyDto[];
    status = Status;
    type: number;
    headerText: string;
    description: string;
    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('salesNotes'), '/app/purchase/purchaseNotess'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _salesNotesServiceProxy: SalesNotesServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {

        this.type = this._activatedRoute.snapshot.queryParams['type'];
        var purhchaseNotesType;

        if (this.type == 1) {
            this.headerText = this.l('CreateInvoice');
            this.description = this.l('CreateInvoiceHeaderInfo');
            purhchaseNotesType = SalesNotesType.SalesDebit;
        } else if (this.type == 2) {
            this.headerText = this.l('CreateCreditNotes');
            this.description = this.l('CreateCreditNotesHeaderInfo');
            purhchaseNotesType = SalesNotesType.SalesCredit;
        }
        else if (this.type == 3) {
            this.headerText = this.l('CreateReceiptFromOthers');
            this.description = this.l('CreateReceiptFromOthersHeaderInfo');
            purhchaseNotesType = SalesNotesType.ReceiptFromOthers;
        }

        this.show(this._activatedRoute.snapshot.queryParams['id']);
        this.addRow(0);
    }

    removeItem(index: number) {
        this.salesNotesDetails.splice(index, 1);

        if (this.salesNotesDetails.length == 0) {
            this.addRow(index);
        }

        var i = 1;
        this.salesNotesDetails.forEach((c) => {
            c.slNo = i++;
        });
    }
     
    focusNext(type: 'description' | 'subTotal' | 'tax' | 'add' | 'nextRow', index: number) {
        if (type === 'description') {
            const next = this.descriptionInputs.get(index);
            next?.nativeElement.focus();
            setTimeout(() => next.nativeElement.select(), 0);
        } else if (type === 'subTotal') {
            const next = this.subTotalInput.get(index);
            next?.nativeElement.focus();
        } else if (type === 'tax') {
            const next = this.taxInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'add') {
            const next = this.addButtons.get(index);
            next?.nativeElement.focus();
        } else if (type === 'nextRow') {
            if (index === this.salesNotesDetails.length - 1) {
                this.addRow(index);
                setTimeout(() => {
                    const nextItem = this.itemCodeInputs.get(index + 1);
                    nextItem?.nativeElement.focus();
                });
            } else {
                const nextItem = this.itemCodeInputs.get(index + 1);
                nextItem?.nativeElement.focus();
            }
        }
    }

    addRow(index: number): void {
        if (this.salesNotesDetails == null) this.salesNotesDetails = [];

        this.salesNotesDetail = new SalesNotesDetailEditDto();
        this.salesNotesDetail.slNo = this.salesNotesDetails.length + 1;
        this.salesNotesDetail.netTotal = 0;
        this.salesNotesDetail.tax = 0;
        this.salesNotesDetails.push(this.salesNotesDetail);
        const nextItem = this.itemCodeInputs.get(index + 1);
        nextItem?.nativeElement.focus();
    }


    show(purchaseNotesId?: number): void {
        if (!purchaseNotesId) {
            this.salesNotes = new SalesNotesEditDto();
            this.salesNotes.id = purchaseNotesId;
            this.salesNotes.transactionDate = this._dateTimeService.getStartOfDay();
            this.customerDisplayProperty = '';
            this.currencyName = '';
            this.paymentTermName = '';
            this.salesNotes.currencyId = null;
            this.salesNotes.accountId = null;
            this.active = true;
        } else {
            this._salesNotesServiceProxy.getSalesNotesForEdit(purchaseNotesId).subscribe((result) => {
                this.salesNotes = result.salesNotes;
                this.salesNotesDetails = result.salesNotesDetailEditDtos;


                this.customerSelectedItem = new FindCustomerOutputDto();
                this.customerSelectedItem.id = this.salesNotes.customerId;
                this.customerSelectedItem.displayName = result.salesNotes.customerName;

                this.active = true;

                if (this._activatedRoute.snapshot.queryParams['dirinv'] == 0) {
                    this.salesNotes.id = null;
                    this.salesNotes.status = this.status.Draft;
                }
            });
        }

        this._commonLookupServiceProxy.getAllCurrencies().subscribe((result) => {
            this.allCurrencys = result;
        });

        this._commonLookupServiceProxy.getAllTaxes().subscribe((result) => {
            this.applicableTaxes = result;
        });

        this._commonLookupServiceProxy.getChartOfAccountForJournals().subscribe((result) => {
            this.allChartOfAccounts = result;
        });

        if (this.type == 3) {
            this._commonLookupServiceProxy.getBankAndCashAccount().subscribe((result) => {
                this.bankAccounts = result;
            });
        }
    }



    getAccountCode(value: any, data: JournalDetailDto,index:number): void {

        var account = this.allChartOfAccounts.find(c => c.id == value.target.value);
        data.accountCode = account.code;
        data.accountId = value.target.value;
        this.focusNext('description', index);
    }

    searchAccount(accountCode: string, data: JournalDetailDto, index: number) {
        var account = this.allChartOfAccounts.find((c) => c.code == accountCode);
        if (account != null) {
            data.accountId = account.id;
            this.focusNext('description', index);
        } else {
            abp.notify.error('AccountNotFound');
            data.accountCode = '';
        }
    }

    amountCalculate(data: SalesNotesDetailEditDto) {
        var itemVendorDiscount = 0;
        debugger;
        let taxRate = 0;
        if (data.taxId > 0) {
            var tax = this.applicableTaxes.find((p) => p.id == data.taxId);
            taxRate = tax.taxPercentage;
            data.tax = parseFloat(((data.subTotal * taxRate) / 100).toFixed(2));
        } else {
            data.tax = 0;
        }
        data.netTotal = Number(data.subTotal) + Number(data.tax);
        this.salesNotes.roundingAmount = 0;
        this.calculateTotalValues();
    }

    calculateTotalValues(): void {
        debugger
        var tempTotSubTotal = 0;
        var tempTotTaxAmt = 0;
        var tempTotNetTotal = 0;
        var tempGrandTotal = 0;
        var totalQty = 0;

        this.salesNotesDetails.forEach((val) => {
            var taxamt = 0;
            val.netTotal = Number(val.subTotal) + Number(val.tax);

            tempTotSubTotal = Number(tempTotSubTotal) + Number(val.subTotal);
            tempTotTaxAmt = Number(tempTotTaxAmt) + Number(val.tax);

            tempTotNetTotal = tempTotNetTotal + Number(val.netTotal);
        });
        this.salesNotes.subTotal = tempTotSubTotal;
        this.salesNotes.tax = tempTotTaxAmt;
        this.salesNotes.netTotal = tempTotSubTotal + tempTotTaxAmt;

        tempGrandTotal =
            this.salesNotes.netTotal +
            Number(this.salesNotes.roundingAmount);

    }

    save(status: any): void {
        this.saving = true;

        this.salesNotes.status = status;
        var purchaseInput = new CreateOrUpdateSalesNotesInput();
        purchaseInput.salesNotes = this.salesNotes;
        purchaseInput.salesNotesDetails = this.salesNotesDetails;
        purchaseInput.salesNotes.type = this.type;
        purchaseInput.salesNotes.status = status;
        purchaseInput.salesNotes.paymentStatus = PaymentStatus.UnPaid;
        this._salesNotesServiceProxy
            .createOrEdit(purchaseInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.navigate();
            });
    }

    navigate() {
        if (this.type == 1) {
            this._router.navigate(['/app/account/salesNotes/invoices/1']);
        } else if (this.type == 2) {
            this._router.navigate(['/app/account/salesNotes/invoices/2']);
        }
        else if (this.type == 3) {
            this._router.navigate(['/app/account/salesNotes/invoices/3']);
        }
    }

    getCustomer(customer: FindCustomerOutputDto) {
        this.salesNotes.customerId = customer.id;
    }

    goBack(): void {
        this._router.navigate(['/app/account/salesNotes/']);
    }
}
